module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEISURBVHgBnZNhDcIwEIWvhP/MAXUADsABOAAH4ABQAA4ABYAChgKGg6GAORjvZcfSLFtX9pIvXdfra3vtGWlQnudjNCQFmTEmEY9Mg8kczQrEIAJWodkOpqmECEZPNav+X3Is1GQOjp7xPZhW//dqYkdSHKlJL41pNcqkXVGIUSQdVGdkwdszJw1ajIkEd8/4BUykbUd4IzGamLdTY3JAkyDmIaHirsDQ6VvfG+p5vK5g6vT5fWoK7ld2EekE1tgMbJ3hD9hoDI/GI5ZPxTgGzImVop7IzQ3UOI6PdDGWUCxu7WltLeRPYc66vGG97qN0FOfSgzmyBJ2NdJMFg1+OmNhOpUEhR+cvjJqR2GCqLOEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/us1.png
// module id = UyMb
// module chunks = 1